import ApiService from 'services/ApiService';

export interface SettingModel {
	id: number;
	key: string;
	value: string;
	affiliateid: number | null;
}

class SettingService extends ApiService<SettingModel> {
	constructor() {
		super('setting');
	}
}

export default new SettingService();
